// extracted by mini-css-extract-plugin
export default {"main":"styles_main__CJaMa","icons":"styles_icons__HMKS9","icon":"styles_icon__f7+wZ"};